import React from 'react';
import { Chip } from '@mui/material';
import {
  TransferOrderStatus,
  TransferOrderRecordStatus,
  getTransferOrderStatusLabel,
  getTransferOrderStatusColor,
  getRecordStatusLabel,
} from '../../types/TransferOrder.types';

interface StatusBadgeProps {
  status: TransferOrderStatus | TransferOrderRecordStatus;
  type?: 'order' | 'record';
  size?: 'small' | 'medium';
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, type = 'order', size = 'small' }) => {
  const getLabel = () => {
    if (type === 'order') {
      return getTransferOrderStatusLabel(status as TransferOrderStatus);
    } else {
      return getRecordStatusLabel(status as TransferOrderRecordStatus);
    }
  };

  const getColor = (): 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info' => {
    if (type === 'order') {
      return getTransferOrderStatusColor(status as TransferOrderStatus);
    }
    // For record status, map to colors
    const recordStatus = status as TransferOrderRecordStatus;
    switch (recordStatus) {
      case TransferOrderRecordStatus.Pending:
        return 'default';
      case TransferOrderRecordStatus.Allocated:
        return 'primary';
      case TransferOrderRecordStatus.Picking:
        return 'warning';
      case TransferOrderRecordStatus.Picked:
        return 'secondary';
      // case TransferOrderRecordStatus.Shipped:
      //   return 'primary';
      case TransferOrderRecordStatus.InTransit:
        return 'info';
      case TransferOrderRecordStatus.Completed:
        return 'success';
      default:
        return 'default';
    }
  };

  return (
    <Chip
      label={getLabel()}
      color={getColor()}
      size={size}
      sx={{
        fontWeight: 600,
        minWidth: 80,
      }}
    />
  );
};

export default StatusBadge;
